module.exports = __webpack_public_path__ + "static/03-icon-7229a9cd71cd95e2681c30eba609512a.png";